import { createElement, Fragment, type PropsWithChildren, type ReactElement } from 'react';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';

import de from './translations/de';
import en from './translations/en';

const translations = {
  en,
  de,
};

interface RootState {
  user: {
    locale?: string;
  };
}

const ConnectedIntlProvider = ({ children }: PropsWithChildren): ReactElement => {
  const locale = useSelector((state: RootState) => state.user.locale ?? 'en');
  const messages = translations[locale as keyof typeof translations];

  return createElement(
    IntlProvider,
    {
      locale,
      key: locale,
      defaultLocale: 'en',
      messages,
      textComponent: Fragment,
    },
    children
  );
};

export default ConnectedIntlProvider;
